/** @format */

import React, { useState, useEffect } from 'react'
import * as Styles from './style'
import { Formik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import Cookies from 'universal-cookie'
import close from '../../../assets/images/close.png'
import { toast } from 'react-toastify'
import { SelectGroup } from '../../../shared/SelectGroup/SelectGroup'
import { InputGroup } from '../../../shared/InputGroup/InputGroup'
import { Button, message } from 'antd'
const readCookie = require('../../../../cookie.js').readCookie

const cookies = new Cookies()

// ✅ Validation Schema
const clfSchema = Yup.object().shape({
  name: Yup.string().required('SHG Name is required'),
})

// ✅ Component
const CreateSHGForm = ({
  showClfModal,
  setShowClfModal,
  onSuccess,
  voName,
  voId,
}) => {
    console.log('CreateVOForm props => ', { showClfModal, voName, voId });
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [blocks, setBlocks] = useState([])
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')

  const token = cookies.get('access_token')

  const handleClose = () => setShowClfModal(false)

  const handleSubmit = async values => {
    setIsSubmitting(true)
    console.log('Form Values:', values)
    try {
      const payload = {
        name: values.name.trim(),
        voId: voId,
        voName: voName,
      }
      console.log('Payload:', payload)

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/humblebee/clf/shg/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            source: 'humblebee_admin',
          },
        }
      )

      toast.success('SHG created successfully')
      onSuccess()
      handleClose()
    } catch (err) {
      toast.error('Failed to create: ' + err?.response?.data?.message || '')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Styles.ModalWrapper style={{ display: showClfModal ? 'flex' : 'none' }}>
      <Styles.ModalContent>
        <Formik
          initialValues={{
            name: '',
            voId: voId,
          }}
          validationSchema={clfSchema}
          onSubmit={handleSubmit}
        >
          {formik => (
            <Styles.FormWithCloseButton onSubmit={formik.handleSubmit}>
              <Styles.CloseButtonDiv>
                <h3>Create New SHG</h3>
                <Styles.FormCloseButton onClick={handleClose}>
                  <img src={close} alt="Close" />
                </Styles.FormCloseButton>
              </Styles.CloseButtonDiv>

              <Styles.MainSupplierFormDiv>
              <InputGroup
                  PlaceholderText={voName}
                  LabelText="VO Name"
                  name="voName"
                  type="text"
                  isDisabled={true}
                  star="*"
                  value={voName}
                />
                <InputGroup
                  PlaceholderText={voId}
                  LabelText="VO Id"
                  name="voID"
                  type="text"
                  isDisabled={true}
                  star="*"
                  value={voId}
                />
                <InputGroup
                  PlaceholderText="Enter SHG Name"
                  LabelText="SHG Name"
                  name="name"
                  type="text"
                  star="*"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                />
              </Styles.MainSupplierFormDiv>

              <Button
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                className="mt-4"
              >
                {isSubmitting ? 'Creating...' : 'Create SHG'}
              </Button>
            </Styles.FormWithCloseButton>
          )}
        </Formik>
      </Styles.ModalContent>
    </Styles.ModalWrapper>
  )
}

export default CreateSHGForm
